import React, { useState, useEffect, useContext } from 'react';
import { PartnerContext } from './PartnerContext';
import { ModeContext } from './ModeContext';
import generalTheme from '../themes/generalTheme';

export const ThemeContext = React.createContext({
  darkMode: false,
  toggleTheme: () => {},
  setPrimaryColor: () => {},
  setSecondaryColor: () => {},
  setTertiaryColor: () => {},
  setBorderWidth: () => {},
  setBorderRadius: () => {},
  setBorderColor: () => {},
  setBoxShadow: () => {},
});

export const ThemeProvider = ({ children }) => {
  const {
    state: { primary_color, secondary_color, theme },
  } = useContext(PartnerContext);
  const {
    state: { adminView },
  } = useContext(ModeContext);

  // const [darkMode, setDarkMode] = useState(
  //   localStorage.getItem('THEME') === 'true' ||
  //   (!localStorage.getItem('THEME') &&
  //     window.matchMedia &&
  //     window.matchMedia('(prefers-color-scheme: dark)').matches)
  // );
  const [darkMode, setDarkMode] = useState(false);

  const [primaryColor, setPrimaryColor] = useState(primary_color);
  const [secondaryColor, setSecondaryColor] = useState(secondary_color);
  const [tertiaryColor, setTertiaryColor] = useState('#ffffff'); // Default value
  const [borderWidth, setBorderWidth] = useState('1px'); // Default value
  const [borderRadius, setBorderRadius] = useState('4px'); // Default value
  const [borderColor, setBorderColor] = useState('#000000'); // Default value
  const [boxShadow, setBoxShadow] = useState('none'); // Default value

  const [finalTheme, setFinalTheme] = useState(generalTheme(primaryColor, secondaryColor, adminView, darkMode, theme));

  useEffect(() => {
    if (primaryColor || secondaryColor || tertiaryColor || borderWidth || borderRadius || borderColor || boxShadow) {
      // console.log('Updating theme with:', { primaryColor, secondaryColor, adminView, darkMode, theme });
      // console.log('HERE IS NEW GENERAL THEME: ', generalTheme(primaryColor, secondaryColor, adminView, darkMode));
      setFinalTheme(
        generalTheme(
          primaryColor,
          secondaryColor,
          adminView,
          darkMode,
          null,
          tertiaryColor,
          borderWidth,
          borderRadius,
          borderColor,
          boxShadow,
        ),
      );
      // console.log('here is general theme after its been tampered with in themeOptions: ', finalTheme);
    } else {
      console.error('Invalid color values:', { primaryColor, secondaryColor });
    }
    // console.log('final theme in theme context: ', finalTheme);
  }, [primaryColor, secondaryColor, tertiaryColor, borderWidth, borderRadius, borderColor, boxShadow]);

  useEffect(() => {
    setFinalTheme(generalTheme(primary_color, secondary_color, adminView, darkMode, theme));
    // console.log('here is final theme in theme context: ', finalTheme);
  }, [adminView, darkMode, theme]);

  useEffect(() => {
    // localStorage.setItem('THEME', darkMode);
    localStorage.setItem('THEME', 'false');
  }, [darkMode]);

  const toggleTheme = () => {
    setDarkMode((prevMode) => !prevMode);
  };

  return (
    <ThemeContext.Provider
      value={{
        state: {
          darkMode,
          toggleTheme,
          finalTheme,
          setPrimaryColor,
          setSecondaryColor,
          setTertiaryColor,
          setBorderWidth,
          setBorderRadius,
          setBorderColor,
          setBoxShadow,
        },
      }}
    >
      {children}
    </ThemeContext.Provider>
  );
};
